export default __webpack_public_path__ + "static/media/rc.06ff34c1.jpeg";